import { Button } from '@/components/ui/button'
import { useFilters } from '@/hooks/useFilters'
import { listContactsQuery } from '@/queries/contact.query'
import { IconDownload, IconPlus, IconRefresh } from '@tabler/icons-react'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useContacts } from '../context/contacts-context'

export function ContactsPrimaryButtons() {
  const { setOpen } = useContacts()
  const queryClient = useQueryClient()
  const { filters } = useFilters('/_authenticated/contacts/')

  const handleUpdateContacts = async () => {
    await queryClient.invalidateQueries(listContactsQuery(filters));
    toast.success('Contatos atualizados')
  }

  return (
    <div className='flex gap-2'>
      <Button
        variant='outline'
        className='space-x-1'
        onClick={handleUpdateContacts}
      >
        <span>Atualizar</span> <IconRefresh size={18} />
      </Button>
      <Button
        variant='outline'
        className='space-x-1'
        onClick={() => setOpen('import')}
      >
        <span>Importar</span> <IconDownload size={18} />
      </Button>
      <Button className='space-x-1' onClick={() => setOpen('create')}>
        <span>Novo Contato</span> <IconPlus size={18} />
      </Button>
    </div>
  )
}
